import React from 'react';
import '../stylesheets/FEVForm.scss';

const fevScores = [
    { score: 0, label: '>95% predicted' },
    { score: 1, label: '95 - 90%' },
    { score: 2, label: '89 - 80%' },
    { score: 3, label: '79 - 70%' },
    { score: 4, label: '69 - 60%' },
    { score: 5, label: '59 - 50%' },
    { score: 6, label: '<50% predicted' },
];

const InputField = ({ label, id }) => {
    return (
        <div className={`input-group`}>
            <label htmlFor={id}>{label}</label>
            <input
                type="number"
                step="0.1"
                id={id}
                disabled
            />
        </div >
    )
}

const ScoreOption = ({ item }) => (
    <div
        className={`score-option`}
        role="button"
    >
        <span>{item.score}</span> = {item.label}
    </div>
);

const ACQ7View = (props) => {

    const { strings } = props

    return (
        <div className="fev-form">
            <h3>To be completed by a member of the clinic staff</h3>
            <p className='subtitle'>Record actual values</p>

            <InputField
                label={'FEV₁pre-bronchodilator'}
                id="fev-pre"
            />
            <InputField
                label={'FEV₁predicted'}
                id="fev-predicted-1"
            />
            <InputField
                label={'FEV₁predicted'}
                id="fev-predicted-2"
            />

            <p>and score the FEV₁% predicted below</p>
            <div className="score-options">
                {fevScores.map((item) => (
                    <ScoreOption
                        key={item.score}
                        item={item}
                    />
                ))}
            </div>
        </div>
    );
};

export default ACQ7View;
